// extracted by mini-css-extract-plugin
module.exports = {"linkNavigation":"Home_linkNavigation__1D6E_","textTop":"Home_textTop__14l5A"};